/**
 * ELITE 2026 LAYER SELECTOR - V2 (Railway API)
 * Award-Winning Product Customizer for Vehicle Floor Mats
 */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', initEliteLayerSelector);

  async function initEliteLayerSelector() {
    const shopifyId = window.eliteProductId;
    
    if (!shopifyId) {
      console.warn('Elite Layer Selector V2: No product ID found');
      return;
    }

    // Configuration - V2 uses Railway API
    const CONFIG = {
      apiEndpoint: 'https://layer-picker-v2-production.up.railway.app/api/products',
      layerTypesOrder: ['mat', 'leather', 'base', 'heel-pad', 'stitching', 'logos', 'border', 'border-stitching'],
      layerTypeNames: {
        'mat': 'Pattern',
        'leather': 'Leather Color',
        'base': 'Base',
        'border': 'Border',
        'heel-pad': 'Trim Color',
        'stitching': 'Stitching',
        'logos': 'Custom Designs',
        'border-stitching': 'Border Stitching'
      },
      layerTypeIcons: {
        'mat': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/></svg>',
        'leather': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/></svg>',
        'base': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/></svg>',
        'border': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><rect x="7" y="7" width="10" height="10" rx="1"/></svg>',
        'heel-pad': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/></svg>',
        'stitching': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>',
        'logos': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
        'border-stitching': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/></svg>'
      }
    };

    // DOM Elements
    const elements = {
      loadingOverlay: document.getElementById('elite-loading'),
      layersContainer: document.getElementById('elite-layers-container'),
      iconsContainer: document.getElementById('elite-icons-container'),
      propertiesContainer: document.getElementById('elite-layers-properties'),
      zoomIn: document.getElementById('elite-zoom-in'),
      zoomOut: document.getElementById('elite-zoom-out'),
      zoomReset: document.getElementById('elite-zoom-reset'),
      zoomLevel: document.getElementById('elite-zoom-level')
    };

    // State
    let state = {
      product: null,
      icons: [],
      groupedIcons: {},
      selectedIcons: {},
      zoomLevel: 1,
      translateX: 0,
      translateY: 0,
      isDragging: false,
      startX: 0,
      startY: 0
    };

    // Zoom constants (must be declared before try block)
    const minScale = 1;
    const maxScale = 3;
    const scaleStep = 0.5;

    // Prefetch container - completely hidden off-screen
    const prefetchContainer = document.createElement('div');
    prefetchContainer.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);clip-path:inset(50%);white-space:nowrap;border:0;padding:0;margin:-1px;opacity:0;visibility:hidden;pointer-events:none;';
    prefetchContainer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(prefetchContainer);

    try {
      // Fetch product data from Railway API
      console.log('Elite Layer Selector V2: Fetching product data for ID:', shopifyId);
      
      const response = await fetch(`${CONFIG.apiEndpoint}/${shopifyId}`);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
      const data = await response.json();
      console.log('Elite Layer Selector V2: Data received:', data);
      
      if (!data || !data.product) {
        throw new Error('Invalid product data received');
      }

      state.product = data.product;
      state.icons = data.icons || [];

      // Store for debugging
      localStorage.setItem(shopifyId, JSON.stringify(data.product));
      window[shopifyId] = data.product;

      // Group icons by type
      state.groupedIcons = state.icons.reduce((acc, icon) => {
        if (!acc[icon.type]) acc[icon.type] = [];
        acc[icon.type].push(icon);
        return acc;
      }, {});

      console.log('Elite Layer Selector V2: Grouped icons:', state.groupedIcons);

      // Preselect first icon of each type
      for (const type in state.groupedIcons) {
        const firstIcon = state.groupedIcons[type][0];
        const matchingLayer = state.product.layers.find(layer => layer.layerIcon.id === firstIcon.id);
        if (matchingLayer) {
          state.selectedIcons[type] = matchingLayer;
        }
      }

      // Prefetch only SELECTED layer images (not all 50+) - Performance optimization
      Object.values(state.selectedIcons).forEach(layer => {
        if (layer && layer.url) {
          const img = document.createElement('img');
          img.loading = 'eager';
          img.decoding = 'async';
          img.src = layer.url;
          prefetchContainer.appendChild(img);
        }
      });

      // Render UI
      renderOptions();
      renderLayers();
      initializeZoomControls();
      
      // Hide loading
      hideLoading();

    } catch (error) {
      console.error('Elite Layer Selector V2: Error:', error);
      showError();
    }

    // ═══════════════════════════════════════════════════════════════════════════
    // RENDER OPTIONS
    // ═══════════════════════════════════════════════════════════════════════════

    function renderOptions() {
      if (!elements.iconsContainer) {
        console.error('Elite Layer Selector V2: Icons container not found');
        return;
      }

      console.log('Elite Layer Selector V2: Rendering options. Grouped icons:', state.groupedIcons);
      elements.iconsContainer.innerHTML = '';

      CONFIG.layerTypesOrder.forEach(type => {
        const options = state.groupedIcons[type];
        if (!options || options.length === 0) return; // Skip if no options

        const section = document.createElement('div');
        section.className = 'elite-options__section';
        section.setAttribute('data-option-type', type);

        // Header
        const header = document.createElement('div');
        header.className = 'elite-options__header';

        const label = document.createElement('div');
        label.className = 'elite-options__label';
        label.innerHTML = `
          <span class="elite-options__label-icon">${CONFIG.layerTypeIcons[type] || ''}</span>
          <span>${CONFIG.layerTypeNames[type] || type}</span>
        `;

        const value = document.createElement('div');
        value.className = 'elite-options__value';
        value.setAttribute('data-value-display', type);
        value.textContent = state.selectedIcons[type] ? state.selectedIcons[type].layerIcon.name : '';

        header.appendChild(label);
        header.appendChild(value);
        section.appendChild(header);

        // Hide section if only one option (like original behavior)
        if (options.length < 2) {
          section.style.display = 'none';
        }

        // Grid of swatches
        const grid = document.createElement('div');
        grid.className = 'elite-options__grid';

        console.log(`Elite Layer Selector V2: Rendering ${options.length} swatches for type "${type}"`);

        options.forEach(icon => {
          const swatch = document.createElement('div');
          swatch.className = 'elite-swatch';
          
          // Use square swatches for borders
          if (type === 'border' || type === 'border-stitching') {
            swatch.classList.add('elite-swatch--square');
          }
          
          swatch.setAttribute('data-type', type);
          swatch.setAttribute('data-icon-id', icon.id);
          swatch.setAttribute('title', icon.name);
          swatch.setAttribute('role', 'button');
          swatch.setAttribute('tabindex', '0');

          // Check if selected
          if (state.selectedIcons[type] && state.selectedIcons[type].layerIcon.id === icon.id) {
            swatch.classList.add('selected');
          }

          // Swatch image - Set loading attributes BEFORE src for proper lazy loading
          const img = document.createElement('img');
          img.className = 'elite-swatch__image';
          img.alt = icon.name || 'Color option';
          img.loading = 'lazy';
          img.decoding = 'async';
          // Set dimensions if available to prevent CLS
          if (icon.width) img.width = icon.width;
          if (icon.height) img.height = icon.height;
          // Set src AFTER loading attribute for true lazy loading
          img.src = icon.url;
          img.onerror = function() {
            this.style.display = 'none';
            swatch.style.background = '#ddd';
          };
          swatch.appendChild(img);

          // Click handler
          swatch.addEventListener('click', () => handleSwatchClick(type, icon, swatch));
          
          // Keyboard handler
          swatch.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleSwatchClick(type, icon, swatch);
            }
          });

          grid.appendChild(swatch);
        });

        section.appendChild(grid);
        elements.iconsContainer.appendChild(section);
      });

      console.log('Elite Layer Selector V2: Options rendered');
    }

    function handleSwatchClick(type, icon, swatchElement) {
      // Don't do anything if already selected
      if (state.selectedIcons[type] && state.selectedIcons[type].layerIcon.id === icon.id) {
        return;
      }

      // Find matching layer
      const matchingLayer = state.product.layers.find(layer => layer.layerIcon.id === icon.id);
      if (!matchingLayer) {
        console.warn('Elite Layer Selector V2: No matching layer found for icon:', icon.id);
        return;
      }

      // Remove selected from previous
      const previousSwatch = document.querySelector(`.elite-swatch[data-type="${type}"].selected`);
      if (previousSwatch) previousSwatch.classList.remove('selected');

      // Update state
      state.selectedIcons[type] = matchingLayer;
      swatchElement.classList.add('selected');

      // Update value display
      const valueDisplay = document.querySelector(`[data-value-display="${type}"]`);
      if (valueDisplay) valueDisplay.textContent = matchingLayer.layerIcon.name;

      // Re-render layers
      renderLayers();
    }

    // ═══════════════════════════════════════════════════════════════════════════
    // RENDER LAYERS
    // ═══════════════════════════════════════════════════════════════════════════

    function renderLayers() {
      if (!elements.layersContainer) return;

      elements.layersContainer.innerHTML = '';
      if (elements.propertiesContainer) elements.propertiesContainer.innerHTML = '';

      // Get and sort selected layers
      const selectedLayers = Object.values(state.selectedIcons);
      selectedLayers.sort((a, b) => 
        CONFIG.layerTypesOrder.indexOf(a.layerIcon.type) - CONFIG.layerTypesOrder.indexOf(b.layerIcon.type)
      );

      selectedLayers.forEach((layer, index) => {
        // Create layer image with dimensions to prevent CLS (Cumulative Layout Shift)
        const layerElement = document.createElement('img');
        layerElement.className = 'elite-layer-preview__layer';
        // Set dimensions BEFORE src to prevent layout shift
        if (layer.width) layerElement.width = layer.width;
        if (layer.height) layerElement.height = layer.height;
        layerElement.decoding = 'async';
        layerElement.src = layer.url;
        layerElement.alt = layer.layerIcon.name;
        layerElement.style.zIndex = index;
        elements.layersContainer.appendChild(layerElement);

        // Create hidden form property (skip 'base')
        if (layer.layerIcon.type !== 'base' && elements.propertiesContainer) {
          const property = document.createElement('input');
          property.type = 'hidden';
          property.name = `properties[${layer.layerIcon.type}]`;
          property.value = layer.layerIcon.name;
          elements.propertiesContainer.appendChild(property);
        }
      });

      updateTransform();
    }

    // ═══════════════════════════════════════════════════════════════════════════
    // ZOOM & PAN CONTROLS
    // ═══════════════════════════════════════════════════════════════════════════

    function initializeZoomControls() {
      const canvas = document.querySelector('.elite-layer-preview__canvas');
      
      // Zoom In Button
      if (elements.zoomIn) {
        elements.zoomIn.addEventListener('click', () => {
          if (state.zoomLevel < maxScale) {
            state.zoomLevel = Math.min(state.zoomLevel + scaleStep, maxScale);
            updateTransform();
          }
        });
      }

      // Zoom Out Button
      if (elements.zoomOut) {
        elements.zoomOut.addEventListener('click', () => {
          if (state.zoomLevel > minScale) {
            state.zoomLevel = Math.max(state.zoomLevel - scaleStep, minScale);
            // Reset position when zooming out to 100%
            if (state.zoomLevel === 1) {
              state.translateX = 0;
              state.translateY = 0;
            }
            updateTransform();
          }
        });
      }

      // Reset Button
      if (elements.zoomReset) {
        elements.zoomReset.addEventListener('click', () => {
          state.zoomLevel = 1;
          state.translateX = 0;
          state.translateY = 0;
          updateTransform();
        });
      }

      // Pan functionality (drag to move when zoomed)
      if (canvas) {
        canvas.addEventListener('mousedown', function(e) {
          if (state.zoomLevel > 1) {
            state.isDragging = true;
            state.startX = e.clientX - state.translateX;
            state.startY = e.clientY - state.translateY;
            if (elements.layersContainer) {
              elements.layersContainer.style.cursor = 'grabbing';
            }
            e.preventDefault();
          }
        });

        canvas.addEventListener('mousemove', function(e) {
          if (state.isDragging && state.zoomLevel > 1) {
            state.translateX = e.clientX - state.startX;
            state.translateY = e.clientY - state.startY;

            // Limit pan boundaries
            const containerRect = canvas.getBoundingClientRect();
            const maxTranslateX = (containerRect.width * (state.zoomLevel - 1)) / 2;
            const maxTranslateY = (containerRect.height * (state.zoomLevel - 1)) / 2;

            state.translateX = Math.max(-maxTranslateX, Math.min(maxTranslateX, state.translateX));
            state.translateY = Math.max(-maxTranslateY, Math.min(maxTranslateY, state.translateY));

            updateTransform();
          }
        });

        canvas.addEventListener('mouseup', function() {
          state.isDragging = false;
          if (elements.layersContainer && state.zoomLevel > 1) {
            elements.layersContainer.style.cursor = 'grab';
          }
        });

        canvas.addEventListener('mouseleave', function() {
          state.isDragging = false;
          if (elements.layersContainer && state.zoomLevel > 1) {
            elements.layersContainer.style.cursor = 'grab';
          }
        });

        // Mouse wheel zoom
        canvas.addEventListener('wheel', function(e) {
          e.preventDefault();
          if (e.deltaY < 0 && state.zoomLevel < maxScale) {
            state.zoomLevel = Math.min(state.zoomLevel + 0.1, maxScale);
          } else if (e.deltaY > 0 && state.zoomLevel > minScale) {
            state.zoomLevel = Math.max(state.zoomLevel - 0.1, minScale);
            if (state.zoomLevel <= 1) {
              state.translateX = 0;
              state.translateY = 0;
            }
          }
          updateTransform();
        });

        // Touch support for mobile
        let touchStartX, touchStartY;

        canvas.addEventListener('touchstart', function(e) {
          if (state.zoomLevel > 1 && e.touches.length === 1) {
            state.isDragging = true;
            touchStartX = e.touches[0].clientX - state.translateX;
            touchStartY = e.touches[0].clientY - state.translateY;
          }
        }, { passive: true });

        canvas.addEventListener('touchmove', function(e) {
          if (state.isDragging && state.zoomLevel > 1 && e.touches.length === 1) {
            state.translateX = e.touches[0].clientX - touchStartX;
            state.translateY = e.touches[0].clientY - touchStartY;

            const containerRect = canvas.getBoundingClientRect();
            const maxTranslateX = (containerRect.width * (state.zoomLevel - 1)) / 2;
            const maxTranslateY = (containerRect.height * (state.zoomLevel - 1)) / 2;

            state.translateX = Math.max(-maxTranslateX, Math.min(maxTranslateX, state.translateX));
            state.translateY = Math.max(-maxTranslateY, Math.min(maxTranslateY, state.translateY));

            updateTransform();
            e.preventDefault();
          }
        }, { passive: false });

        canvas.addEventListener('touchend', function() {
          state.isDragging = false;
        }, { passive: true });

        // Double-click to reset view
        canvas.addEventListener('dblclick', function() {
          state.zoomLevel = 1;
          state.translateX = 0;
          state.translateY = 0;
          updateTransform();
        });
      }
    }

    function updateTransform() {
      if (elements.layersContainer) {
        elements.layersContainer.style.transform = `translate(${state.translateX}px, ${state.translateY}px) scale(${state.zoomLevel})`;
        elements.layersContainer.style.cursor = state.zoomLevel > 1 ? 'grab' : 'default';
      }
      // Update zoom level display
      if (elements.zoomLevel) {
        elements.zoomLevel.textContent = Math.round(state.zoomLevel * 100) + '%';
      }
      // Update button states
      if (elements.zoomIn) elements.zoomIn.disabled = state.zoomLevel >= maxScale;
      if (elements.zoomOut) elements.zoomOut.disabled = state.zoomLevel <= minScale;
    }

    // ═══════════════════════════════════════════════════════════════════════════
    // UI STATES
    // ═══════════════════════════════════════════════════════════════════════════

    function hideLoading() {
      // Hide loading spinner
      if (elements.loadingOverlay) {
        elements.loadingOverlay.classList.add('hidden');
        setTimeout(() => elements.loadingOverlay.style.display = 'none', 400);
      }
      // Hide skeleton LCP image once real layers are loaded
      const skeleton = document.getElementById('elite-skeleton');
      if (skeleton) {
        skeleton.classList.add('hidden');
        setTimeout(() => skeleton.style.display = 'none', 400);
      }
    }

    function showError() {
      if (elements.loadingOverlay) {
        elements.loadingOverlay.innerHTML = `
          <div style="text-align:center;color:#6b7280;">
            <svg style="width:48px;height:48px;color:#F26522;margin-bottom:16px;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <p style="font-size:14px;margin:0;">Unable to load customization options.</p>
            <p style="font-size:13px;color:#9ca3af;margin:8px 0 0;">Please refresh the page to try again.</p>
          </div>
        `;
      }
    }
  }
})();
